<script>
  import { addedToCartDialog } from "@store"
  import { toHuman } from "@helpers/formatters/currency"
  import route from "@helpers/route"
  import ProtectedImage from "@components/ProtectedImage.svelte"
  import Dialog from "@components/Dialog.svelte"
  import DialogBody from "@components/DialogBody.svelte"
  import Button from "@components/Button.svelte"
  import ShippingFeeIncludedCaption from "../ShippingFeeIncludedCaption.svelte"
  import { getSingularUnitName } from "@helpers/models/product"

  $: item = $addedToCartDialog.item
  $: closed = $addedToCartDialog.closed

  $: singularUnitName = item?.is_sample_request ? "unit" : getSingularUnitName(item?.product)

  function close() {
    addedToCartDialog.close()
  }
</script>

{#if item && !closed}
  <Dialog on:close={close}>
    <DialogBody
      class="
        [ max-w-[95%] md:max-w-[85%] lg:max-w-[42rem] ]
        [ w-full bg-canvas p-6 pt-8 z-modal rounded-md shadow-lg ]
        [ md:px-9 md:py-10 ]
      "
    >
      <div class="[ relative ]">
        <header class="[ text-center mb-16 ]">
          <h1 id="modal-title" class="[ font-functional text-2xl tracking-tight ]">
            Item has been added to your shopping cart
          </h1>
        </header>

        <div class="[ grid gap-4 ]">
          <div class="[ grid grid-cols-4 gap-8 mb-8 ]">
            <div class="[ col-span-1 ]">
              <ProtectedImage
                src={item.featured_image.url}
                alt={item.name}
                aspect="square"
                width="100"
                class="[ rounded ]"
              />
            </div>

            <div class="[ col-span-3 flex flex-wrap md:flex-nowrap ]">
              <div class="[ leading-loose md:w-auto ]">
                <h3 class="[ text-2xl leading-tight pr-12 -mt-2 ]">{item.name}</h3>
                <p class="[ font-bold text-lg ]">{toHuman(item.unit_price)} per {singularUnitName}</p>
                <p>Quantity: {item.quantity}</p>
              </div>

              <div class="[ w-full md:w-auto md:ml-auto ]">
                <p class="[ font-bold text-lg text-right ]">{toHuman(item.total)}</p>
              </div>
            </div>
          </div>

          <div>
            <dl class="[ flex justify-between ]">
              <dt class="[ leading-tight ]">
                <span class="[ text-xl font-semibold tracking-tight ]">Your cart subtotal</span>
                <ShippingFeeIncludedCaption />
              </dt>

              <dd class="[ font-semibold text-2xl tracking-tighter ]">{toHuman(item.cart.total)}</dd>
            </dl>
          </div>

          <div class="[ mt-8 grid gap-4 md:grid-cols-2 mt-4 ]">
            <Button href={route("shop.checkout.cart.store")}>View your cart</Button>
            <Button type="neutral" on:click={close}>Continue shopping</Button>
          </div>
        </div>
      </div>
    </DialogBody>
  </Dialog>
{/if}
